import { HabitSchedule } from '@griply/types';
import {
  getTimeframeDateEntries,
  GetTimeframeDateEntriesOptions,
} from '@griply/utils';
import { useMemo } from 'react';

export type Options = GetTimeframeDateEntriesOptions;

export const useTimeframeEntries = (
  schedules: HabitSchedule[],
  { startDate, endDate }: Options,
) =>
  useMemo(
    () => getTimeframeDateEntries(schedules, { startDate, endDate }),
    [endDate, schedules, startDate],
  );
